import React from 'react';
import { Layout, Flex, Typography, Menu } from 'antd';
import './pageLayout.less'
import logo from '../static/logo.png'
import qrcode from '../static/qrcode.jpg'
import public_security_icon from '../static/public_security_icon.png'
const { Content, Footer, Header } = Layout;
const { Text, Link } = Typography;

const items: any[] = [
  { label: '首页', key: 'menu1', path: '' },
  {
    label: '关于我们', key: 'menu2',
    children: [
      { label: '简介', key: 'menu21', path: 'foundation-intro' },
      { label: '郁金香章程', key: 'menu22', path: 'constitution' },
      { label: '证照', key: 'menu23', path: 'certificates' },
      { label: '荣誉获奖证书', key: 'menu24', path: 'honors' },
      { label: '理事会成员', key: 'menu25', path: 'board-members' },
      { label: '合作伙伴', key: 'menu26', path: 'partners' }
    ]
  },
  {
    label: '信息公开', key: 'menu3',
    children: [
      { label: '制度', key: 'menu31', path: 'regulations' },
      { label: '审计报告', key: 'menu32', path: 'audit-reports' },
      { label: '年度报告', key: 'menu33', path: 'annual-reports' },
      { label: '立项报告', key: 'menu34', path: 'project-disclosure' },
      { label: '理事会资料', key: 'menu35', path: 'board-materials' }
    ]
  }
];

type PageOwnProps = {
  children: React.ReactNode[];
  Content: any,
  history: any
}

type PageState = {
  collapsed: boolean,
  current: string
}



class PageLayout extends React.Component<PageOwnProps, PageState> {

  constructor(props: any, context: any) {
    super(props, context)
    this.state = {
      collapsed: false,
      current: ''
    }
  }

  componentDidMount() {
    const path = this.props.history.location.pathname.substring(1);
    const findItemByPath = (menuItems: any[], path: string) => {
      for (const item of menuItems) {
        if (item.path === path) {
          return item.key;
        }
        if (item.children) {
          const found:any[] = findItemByPath(item.children, path);
          if (found) return found;
        }
      }
    };
    this.setState({ current: findItemByPath(items, path) });
  }



  onChange(value: any) {
    if (this.props.history.location.pathname !== '/') {
      this.goHome();
      this.setState({ current: 'menu1' }); // 重置菜单选中状态
    }
  }


  goHome() {
    this.props.history.push('/')
  }
  changeMenu(e: any) {
    const findItemByKey = (menuItems: any[] | null | undefined, key: string) => {
      if (!menuItems) return null;
      for (const item of menuItems) {
        if (item.key === key) {
          return item;
        }
        if (item.children) {
          const found:any[] = findItemByKey(item.children, key);
          if (found) return found;
        }
      }
      return null;
    };

    const selectedItem = findItemByKey(items, e.key);
    if (selectedItem) {
      this.setState({ current: e.key }, () => {
        if (selectedItem.path !== undefined) {
          this.props.history.push(`/${encodeURIComponent(selectedItem.path)}`);
        }
      });
    }
  }


  render() {
    const { current } = this.state
    return <Layout className='appcontent'>
      <Header style={{ padding: '0 40px', height: '72px', lineHeight: '72px' }}>
        <Flex style={{ height: '72px' }} justify={'space-between'} align={'center'}>
          <Flex gap={16} justify={'flex-start'} align={'center'}>
            <img
              className="header-logo"
              alt="郁金香陪伴"
              src={logo}
              onClick={() => this.props.history.push('/')}
            />
            <Menu
              style={{ lineHeight: '70px', backgroundColor: 'transparent', borderBottom: 'none', flex: 1 }}
              onClick={this.changeMenu.bind(this)}
              selectedKeys={[current]}
              mode="horizontal"
              items={items}
            />
          </Flex>
          <div className="header-contact">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" fill="#EE3172"/>
            </svg>
            <span>亲亲老师 13868063096</span>
          </div>
        </Flex>
      </Header>
      <Content
        className="site-layout-background"
        style={{ minHeight: 'calc(100vh - 72px - 180px)' }}
      >
        {this.props.Content}
      </Content>
      <Footer style={{ backgroundColor: '#1a1a2e', padding: '0' }}>
        <div className="footer-inner">
          <div className="footer-main">
            <div className="footer-info">
              <div className="footer-brand">郁金香陪伴</div>
              <div className="footer-links">
                <Text style={{ color: '#aaa' }}>📞 亲亲老师 13868063096</Text>
                <Text style={{ color: '#aaa' }}>📍 杭州市杭大路黄龙世纪广场 A座10楼</Text>
                <Text style={{ color: '#aaa' }}>📱 微信公众号：郁金香陪伴</Text>
                <Text style={{ color: '#aaa' }}>💬 微信小编：yjxygh</Text>
              </div>
            </div>
            <div className="footer-qr">
              <img alt="微信公众号二维码" className="footer-qr-img" src={qrcode} />
              <span className="footer-qr-label">扫码关注公众号</span>
            </div>
          </div>
          <div className="footer-bottom">
            <Text style={{ color: '#888' }}>©2025 郁金香陪伴 版权所有</Text>
            <Link
              className="footer-beian-link"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              rel="noreferrer"
            >
              <img alt="公安备案" className="footer-security-icon" src={public_security_icon} />
              浙ICP备20000587号-1
            </Link>
          </div>
        </div>
      </Footer>
    </Layout>
  }
}



export default PageLayout